import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";
import { AssessmentScoreRosterResponseDto } from "../../shared/dtos/assessmentScore/AssessmentScoreRosterResponseDto";

export interface AssessmentScoreState {
  loadingScoreRoster: boolean;
  loadingScoreBulk: boolean;
  errorLoadingScoreRoster: string | null;
  errorSavingScores: string | null;
  scoreRoster: AssessmentScoreRosterResponseDto[];
  serverStatus: ServerStatusPayload | null;
}

const initialState: AssessmentScoreState = {
  loadingScoreRoster: false,
  loadingScoreBulk: false,
  errorLoadingScoreRoster: null,
  errorSavingScores: null,
  scoreRoster: [],
  serverStatus: null,
};

export const assessmentScoreSlice = createSlice({
  name: "assessmentScore",
  initialState,
  reducers: {
    setLoadingScoreRoster(state) {
      state.loadingScoreRoster = true;
      state.errorLoadingScoreRoster = null;
    },
    setLoadingScoreBulk(state) {
      state.loadingScoreBulk = true;
      state.errorSavingScores = null;
    },
    setErrorLoadingScoreRoster(state, action: PayloadAction<string | null>) {
      state.loadingScoreRoster = false;
      state.errorLoadingScoreRoster = action.payload;
    },
    setErrorSavingScores(state, action: PayloadAction<string | null>) {
      state.loadingScoreBulk = false;
      state.errorSavingScores = action.payload;
    },
    setScoreRoster(
      state,
      action: PayloadAction<AssessmentScoreRosterResponseDto[]>,
    ) {
      state.loadingScoreRoster = false;
      state.scoreRoster = action.payload;
    },
    saveScoresSuccess(state) {
      state.loadingScoreBulk = false;
    },
    setServerResponseStatus(
      state,
      action: PayloadAction<ServerStatusPayload | null>,
    ) {
      state.serverStatus = action.payload;
    },
  },
});

export const assessmentScoreActions = assessmentScoreSlice.actions;
export default assessmentScoreSlice.reducer;
